// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})

// Home select filters Agenda
if (document.body.classList.contains('home')) {
    const filterEventsBtn = document.querySelector('.events__filters--btn');

    filterEventsBtn.addEventListener('click', () => {
        let filterEventsCategory = document.getElementById('events__category').value;
        let filterEventsStartDate = document.getElementById('startDateFilterHidden').value;
        let filterEventEndDate = document.getElementById('endDateFilterHidden').value;
        
        let urlFiltersSearch = window.location.href + 'systeme/agenda/?systemeParams=events';

        /*if ( filterEventsCategory != '#' ) || ( filterEventsStartDate != '' ) || ( filterEventEndDate != '' ) {
            window.location.href = urlFiltersSearch + "&category=" + filterEventsCategory + "&startDate=" + filterEventsStartDate + "&endDate=" + filterEventEndDate;
        }*/
        

        if ( filterEventsCategory != '0' ) {
            urlFiltersSearch = urlFiltersSearch + "&category=" + filterEventsCategory;
            window.location.href = urlFiltersSearch;
            
            if ( filterEventsStartDate != '' ) {
            urlFiltersSearch =  urlFiltersSearch + "&startDate=" + filterEventsStartDate;
            window.location.href = urlFiltersSearch;

            if ( filterEventEndDate != '' ) {
                urlFiltersSearch =  urlFiltersSearch + "&endDate=" + filterEventEndDate;
                window.location.href = urlFiltersSearch;
            }
            }

            else if ( filterEventEndDate != '' ) {
            urlFiltersSearch =  urlFiltersSearch + "&startDate=" + filterEventEndDate;
            window.location.href = urlFiltersSearch;

            if ( filterEventsStartDate != '' ) {
                urlFiltersSearch =  urlFiltersSearch + "&endDate=" + filterEventsStartDate;
                window.location.href = urlFiltersSearch;
            }
            }
        }
        
        else if ( filterEventsStartDate != '' ) {
            urlFiltersSearch = urlFiltersSearch + "&startDate=" + filterEventsStartDate;
            window.location.href = urlFiltersSearch;
            
            if ( filterEventsCategory != '0' ) {
            urlFiltersSearch =  urlFiltersSearch + "&category=" + filterEventsCategory;
            window.location.href = urlFiltersSearch;

            if ( filterEventEndDate != '' ) {
                urlFiltersSearch =  urlFiltersSearch + "&endDate=" + filterEventEndDate;
                window.location.href = urlFiltersSearch;
            }
            }

            else if ( filterEventEndDate != '' ) {
            urlFiltersSearch =  urlFiltersSearch + "&endDate=" + filterEventEndDate;
            window.location.href = urlFiltersSearch;

            if ( filterEventsCategory != '0' ) {
                urlFiltersSearch =  urlFiltersSearch + "&category=" + filterEventsCategory;
                window.location.href = urlFiltersSearch;
            }
            }
        }
        
        else if ( filterEventEndDate != '' ) {
            urlFiltersSearch = urlFiltersSearch + "&endDate=" + filterEventEndDate;
            window.location.href = urlFiltersSearch;
            
            if ( filterEventsStartDate != '' ) {
            urlFiltersSearch =  urlFiltersSearch + "&startDate=" + filterEventsStartDate;
            window.location.href = urlFiltersSearch;

            if ( filterEventsCategory != '0' ) {
                urlFiltersSearch =  urlFiltersSearch + "&category=" + filterEventsCategory;
                window.location.href = urlFiltersSearch;
            }
            }

            else if ( filterEventsCategory != '0' ) {
            urlFiltersSearch =  urlFiltersSearch + "&category=" + filterEventsCategory;
            window.location.href = urlFiltersSearch;

            if ( filterEventsStartDate != '' ) {
                urlFiltersSearch =  urlFiltersSearch + "&startDate=" + filterEventsStartDate;
                window.location.href = urlFiltersSearch;
            }
            }
        }

    });
}